export interface IUploadState {
    isLoading: boolean;
}

export const initialUploadState: IUploadState = {
    isLoading: false,
}
